<form [formGroup]="queryForm" (ngSubmit)="addQuery()" enctype="multipart/form-data">
  <div class="row">
      <div class="col-md-12">
          <div class="col-lg-12">
              <div class="row">

                  <div class="col-md-6 d-flex padding-right-2 padding-left-2">
                      <div class="card flex-fill add-mrf-card">
                          <div class="card-body card-padding-bottom">
                              <h3 class="card-title page-header0"> <i class="fa fa-user"></i>&nbsp;User Details</h3>
                              <hr>



                              <section *ngIf="!isbehalf">
                                  <div class="row">
                                      <label class="col-form-label col-md-4 col-sm-4">Employee Name <span class="form-error">*</span></label>
                                      <div class="col-md-8 col-sm-8"><input type="text" class="form-control" readonly disabled value="{{Empname}}"></div>
                                  </div>
                                  <div class="row">
                                      <div class="col-form-label  col-md-4 col-sm-4">
                                          Mobile No.
                                      </div>
                                      <div class="col-form-label col-md-8 col-sm-8" *ngIf="userContact">
                                          <ul style="padding: 0px;">
                                              <li>{{userContact.cont_1}}</li>

                                          </ul>

                                      </div>
                                  </div>

                              </section>


                              <section *ngIf="isbehalf ">
                                  <div class="row">
                                      <div class="col-form-label  col-md-4 col-sm-4">
                                          Bulk Query Generate
                                      </div>
                                      <div class="col-form-label col-md-4 col-sm-4">
                                          <a href="assets/bulk_query_format.xlsx" style="color: black;">
                                              <button type="button" class="btn btn-sm btn-primary">Download Format</button>
                                          </a>
                                      </div>
                                      <div class="col-form-label col-md-4 col-sm-4">
                                          <input type="file" class="btn btn-default" accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel" (change)="excelRead($event)" #myInput />
                                      </div>
                                  </div>
                              </section>



                          </div>
                      </div>
                  </div>

                  <div class="col-md-6 d-flex padding-left-2 padding-right-2">
                      <div class="card flex-fill add-mrf-card">
                          <div class="card-body card-padding-bottom">
                              <h3 class="card-title page-header0"><i class="fa fa-location-arrow"></i>&nbsp;Problem Details</h3>
                              <hr>
                              <ul class="personal-info">


                                  <li>
                                      <div class="title">Query Sub Category <span class="form-error">*</span></div>
                                      <div class="text">
                                          <!-- (change)="getSub2Category($event)" -->
                                          <select id="subcat1_name" class="form-control" formControlName="sub_cat1" (change)="mandateDoc()">
                                                 <option value="" >Select....</option>
                                                 <option value={{data.subcat1_id}} *ngFor="let data of subCategList">{{data.subcat1_desc}}</option>
                                           </select>
                                          <div *ngIf="submitted && queryCont.sub_cat1.errors" class="form-error">
                                              <div *ngIf="queryCont.sub_cat1.errors.required">Query Sub Category Required</div>
                                          </div>
                                      </div>
                                  </li>
                                  <li>

                                  </li>
                              </ul>
                          </div>
                      </div>
                  </div>

              </div>




              <div class="row">

                  <div class="col-md-6 d-flex padding-left-2 padding-right-2">
                      <div class="card flex-fill add-mrf-card">
                          <div class="card-body card-padding-bottom">
                              <h3 class="card-title page-header0"> <i class="fa fa-book"></i>&nbsp;Document:</h3>
                              <hr>
                              <div class="row">
                                  <div class="col-form-label col-md-4 col-sm-4">
                                      priority <span class="form-error">*</span>
                                  </div>
                                  <div class="col-form-label col-md-8 col-sm-8">
                                      <select id="priority" class="form-control" formControlName="priority">
                                                 <option value="low" >Low</option>
                                                 <option value="medium" >Medium</option>
                                                 <option value="high" >High</option>

                                           </select>
                                      <div *ngIf="submitted && queryCont.priority.errors" class="form-error">
                                          <div *ngIf="queryCont.priority.errors.required">Priority Required</div>
                                      </div>
                                  </div>
                              </div>
                              <div class="row">

                                  <div class="col-form-label col-md-4 col-sm-4">
                                      Upload Document
                                  </div>
                                  <div class="col-form-label col-md-8 col-sm-8">
                                      <input type="file" formControlName="doc" class="form-control" (change)="onFileChange($event)">
                                      <div *ngIf="submitted && queryCont.doc.errors" class="form-error">
                                          <div *ngIf="queryCont.doc.errors.required">**Docs Required</div>
                                      </div>

                                      <small class="form-text text-danger">Please upload only pdf,MS word file,gif,jpg & png.For ID card(Upload your passport size photo with clean background)</small>
                                  </div>
                              </div>

                              <!-- service support fields  -->

                          </div>
                      </div>
                  </div>

                  <div class="col-md-6 d-flex padding-left-2 padding-right-2">
                      <div class="card flex-fill add-mrf-card">
                          <div class="card-body card-padding-bottom">
                              <h3 class="card-title page-header0"> <i class="fa fa-book"></i>&nbsp;Comments:</h3>
                              <hr>

                              <div class="row">

                                  <div class="col-md-12 col-sm-12 mb-1">
                                      <textarea rows="3" class="form-control" formControlName="remark" placeholder="{{placeholderText}}"></textarea>
                                  </div>
                                  <div *ngIf="submitted && queryCont.remark.errors" class="form-error">
                                      <div *ngIf="queryCont.remark.errors.required">Comments Required</div>
                                  </div>
                              </div>

                              <!-- service support fields  -->

                          </div>
                      </div>
                  </div>
              </div>

              <div class="row">
                  <div class="col-md-12">
                      <section class="text-center add-p-tb">

                          <button type="submit" class="btn btn-primary" [disabled]="loading"><span *ngIf="loading" class="spinner-border spinner-border-sm mr-1"></span><i class="fa fa-save"></i> Create Query</button>
                      </section>
                  </div>
              </div>


          </div>
      </div>
  </div>
</form>
